var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h6',{staticClass:"text-center py-5"},[_vm._v(" دیتایی برای نمایش وجود ندارد ")])}
var staticRenderFns = []

export { render, staticRenderFns }